import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/admin/guard';
import { UserDetail } from '@/features/admin/users/user-detail';

export const Route = createFileRoute('/_app/admin/users/$userId')({
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'admin.users');
  },
  component: UserPage,
});

function UserPage() {
  const { userId } = Route.useParams();
  return <UserDetail userId={userId} />;
}
